import { ErrorHandler, inject, Injectable, InjectionToken } from '@angular/core';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

export const BugsnagHandler = new InjectionToken<BugsnagErrorHandler>('BugsnagHandlerToken');

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  readonly #bugsnagHandler = inject(BugsnagHandler);

  handleError(error: any): void {
    this.#bugsnagHandler.handleError(error);
  }
}
